import { GetListResponse, instance } from "libs/api";

import { ApiRoutesBoxMovements } from "../../constants";
import { BoxMovement, GetBoxMovementsParams } from "../../transfers.types";

export const requestGetBoxMovements = async (
  params: GetBoxMovementsParams,
): Promise<GetListResponse<BoxMovement>> => {
  return await instance.get(ApiRoutesBoxMovements.BoxMovements, { params });
};
